<div class="subtask-list">
  <div class="subtask-list__header">
    <span class="subtask-list__header-title">{{ 'Tasks.subtasks' | translate }}</span>
    <app-button
      *ngIf="!addingTask()"
      (click)="addTask()"
      [config]="{
        size: ButtonSize.LARGE,
        type: ButtonTypes.NEW_SECONDARY_NO_BORDER_BLUE,
        text: 'Tasks.addSubtask' | translate,
        prependSrc: './assets/img/plus-icon-blue.svg'
      }"
    />
  </div>

  <div class="subtask-list__list">
    <subtask-create *ngIf="addingTask()" (discard)="discardAdding()" [parentId]="parentId" />

    <subtasks-list />
  </div>
</div>
